import React, { useMemo } from "react";
import { Card, Row, Col } from "react-bootstrap";
import ReactEcharts from "echarts-for-react";
import { useTranslation } from "react-i18next";
import { GREEN, YELLOW, RED, GREY, BLUE, shadeColor } from "@helper/colors";

const style = {
  height: "420px",
  width: "100%",
};

export default function UsageDistributionChart({ data }) {
  const { t } = useTranslation();

  const usageCounts = useMemo(() => {
    const counts = {
      sold: 0,
      rented: 0,
      replaced: 0,
      lost: 0,
      research: 0,
      none: 0,
    };
    if (Array.isArray(data)) {
      data.forEach((sensor) => {
        const usage = sensor.usage || "none";
        if (counts[usage] !== undefined) {
          counts[usage]++;
        } else {
          counts["none"]++;
        }
      });
    }
    return counts;
  }, [data]);

  const totalSensors = Array.isArray(data) ? data.length : 0;

  const chartData = [
    { name: t("sold"), value: usageCounts.sold, itemStyle: { color: GREEN } },
    { name: t("rented"), value: usageCounts.rented, itemStyle: { color: BLUE } },
    { name: t("replaced"), value: usageCounts.replaced, itemStyle: { color: YELLOW } },
    { name: t("lost"), value: usageCounts.lost, itemStyle: { color: RED } },
    {
      name: t("research"),
      value: usageCounts.research,
      itemStyle: { color: shadeColor(BLUE, 20) },
    },
    { name: t("none"), value: usageCounts.none, itemStyle: { color: GREY } },
  ].filter((item) => item.value > 0);

  const option = {
    tooltip: { trigger: "item" },
    legend: { show: false },
    title: {
      text: totalSensors.toString(),
      subtext: t("dashboard.total_produced"),
      left: "center",
      top: "center",
      textStyle: { fontSize: 24, fontWeight: "bold" },
      subtextStyle: { fontSize: 14 },
    },
    series: [
      {
        name: t("dashboard.usage_distribution"),
        type: "pie",
        radius: ["50%", "70%"],
        center: ["50%", "50%"],
        avoidLabelOverlap: false,
        label: { show: false, position: "center" },
        labelLine: { show: false },
        cursor: "default",
        data: chartData,
      },
    ],
  };

  return (
    <Card role="dashboard" className="dashboard-panel">
      <Card.Header className="dashboard-panel-header">
        <h6 className="mb-0">{t("dashboard.usage_distribution")}</h6>
      </Card.Header>
      <Card.Body>
        <ReactEcharts option={option} style={style} notMerge />
        <div className="dashboard-health-overview">
          <Row>
            {chartData.map((entry, index) => {
              const percentage =
                totalSensors > 0 ? Math.round((entry.value / totalSensors) * 100) : 0;
              return (
                <Col lg="4" md={6} xs={6} key={index} className="dashboard-health-item">
                  <span className="dashboard-health-label">{entry.name}</span>
                  <div className="dashboard-health-stats">
                    <span
                      className="dashboard-health-dot"
                      style={{ background: entry.itemStyle.color }}
                    />
                    <span className="dashboard-health-value">{entry.value}</span>
                    <span className="dashboard-health-percent">{percentage}%</span>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
}
